(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-discovery-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const dataNode = root.querySelector('[data-ooam-catalog-data]');
      if (!dataNode) return;
      const catalog = JSON.parse(dataNode.textContent);
      const selected = new Set();
      let activeFilter = 'all';
      const bar = root.querySelector('[data-ooam-bar]');
      const selectionText = root.querySelector('[data-ooam-selection]');
      const openButton = root.querySelector('[data-ooam-open]');
      const dialog = root.querySelector('[data-ooam-dialog]');
      const dialogGrid = root.querySelector('[data-ooam-grid]');
      const empty = root.querySelector('[data-ooam-empty]');
      const count = root.querySelector('[data-ooam-count]');

      const handleFromLink = (link) => {
        if (!link) return '';
        const match = link.getAttribute('href').match(/\/products\/([^?/#]+)/);
        return match ? match[1] : '';
      };

      const cardEntries = () => Array.from(document.querySelectorAll('#product-grid .grid__item')).map((card) => {
        const link = card.querySelector('a[href*="/products/"]');
        return { card, handle: handleFromLink(link) };
      }).filter((entry) => catalog[entry.handle]);

      const syncSelection = () => {
        const titles = Array.from(selected).map((handle) => catalog[handle].title);
        bar.hidden = selected.size === 0;
        selectionText.textContent = selected.size ? `${root.dataset.selectedLabel}: ${titles.join(' + ')}` : '';
        openButton.disabled = selected.size !== 2;
        cardEntries().forEach(({ card, handle }) => {
          const button = card.querySelector('[data-ooam-compare-toggle]');
          if (!button) return;
          const isSelected = selected.has(handle);
          button.setAttribute('aria-pressed', String(isSelected));
          const label = isSelected ? root.dataset.removeLabel : root.dataset.addLabel;
          if (button.textContent !== label) button.textContent = label;
        });
      };

      const decorateCards = () => {
        cardEntries().forEach(({ card, handle }) => {
          if (card.querySelector('[data-ooam-compare-toggle]')) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ooam-compare-toggle';
          button.dataset.ooamCompareToggle = handle;
          button.setAttribute('aria-pressed', 'false');
          button.textContent = root.dataset.addLabel;
          button.addEventListener('click', () => {
            if (selected.has(handle)) selected.delete(handle);
            else if (selected.size < 2) selected.add(handle);
            else {
              selectionText.textContent = root.dataset.maxLabel;
              bar.hidden = false;
              return;
            }
            syncSelection();
          });
          const wrapper = card.querySelector('.card-wrapper') || card;
          wrapper.appendChild(button);
        });
        syncSelection();
      };

      const applyFilter = () => {
        let visible = 0;
        cardEntries().forEach(({ card, handle }) => {
          const show = activeFilter === 'all' || catalog[handle].needs.includes(activeFilter);
          card.hidden = !show;
          if (show) visible += 1;
        });
        count.textContent = String(visible);
        empty.hidden = visible !== 0;
      };

      const addComparisonRow = (container, label, value) => {
        const row = document.createElement('div');
        row.className = 'ooam-compare-row';
        const heading = document.createElement('strong');
        heading.textContent = label;
        const copy = document.createElement('p');
        copy.textContent = value;
        row.append(heading, copy);
        container.appendChild(row);
      };

      const buildComparison = () => {
        dialogGrid.replaceChildren();
        Array.from(selected).forEach((handle) => {
          const course = catalog[handle];
          const card = document.createElement('article');
          card.className = 'ooam-compare-card';
          if (course.image) {
            const image = document.createElement('img');
            image.src = course.image;
            image.alt = course.title;
            image.loading = 'lazy';
            card.appendChild(image);
          }
          const copy = document.createElement('div');
          copy.className = 'ooam-compare-card__copy';
          const title = document.createElement('h3');
          title.textContent = course.title;
          const price = document.createElement('p');
          price.className = 'ooam-compare-card__price';
          price.textContent = course.price;
          copy.append(title, price);
          addComparisonRow(copy, dialog.dataset.needLabel, course.need);
          addComparisonRow(copy, dialog.dataset.focusLabel, course.focus);
          addComparisonRow(copy, dialog.dataset.outcomeLabel, course.outcome);
          const link = document.createElement('a');
          link.className = 'button';
          link.href = course.url;
          link.textContent = dialog.dataset.courseLabel;
          copy.appendChild(link);
          card.appendChild(copy);
          dialogGrid.appendChild(card);
        });
      };

      root.querySelectorAll('[data-ooam-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.ooamFilter;
          root.querySelectorAll('[data-ooam-filter]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          applyFilter();
        });
      });
      root.querySelector('[data-ooam-clear]').addEventListener('click', () => {
        selected.clear();
        syncSelection();
      });
      openButton.addEventListener('click', () => {
        if (selected.size !== 2) return;
        buildComparison();
        dialog.showModal();
      });
      root.querySelector('[data-ooam-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      const grid = document.querySelector('#product-grid');
      if (grid) new MutationObserver(() => { decorateCards(); applyFilter(); }).observe(grid, { childList: true, subtree: true });
      decorateCards();
      applyFilter();
    };

    document.querySelectorAll('.ooam-catalog-tools').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.ooam-catalog-tools').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-fit-check"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const choices = Array.from(root.querySelectorAll('[data-ooam-fit-choice]'));
      const result = root.querySelector('[data-ooam-fit-result]');
      const selection = root.querySelector('[data-ooam-fit-selection]');
      choices.forEach((button) => {
        button.addEventListener('click', () => {
          choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
          selection.textContent = button.textContent.trim();
          result.hidden = false;
          result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      root.querySelector('[data-ooam-fit-reset]').addEventListener('click', () => {
        choices.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
        result.hidden = true;
        choices[0].focus();
      });
      root.querySelector('[data-ooam-fit-continue]').addEventListener('click', () => {
        const buyButton = document.querySelector('button[name="add"]');
        if (!buyButton) return;
        buyButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => buyButton.focus({ preventScroll: true }), 450);
      });
    };
    document.querySelectorAll('.ooam-fit-check').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.ooam-fit-check').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
